import React from "react";
import PropTypes from "prop-types";
// import ContentSectionModule from "components/organisms/ContentSectionModule/ContentSectionModule";
// import StorageUnitSizeChart from "components/organisms/StorageUnitSizeChart/StorageUnitSizeChart";
// import RichContentSection from "components/organisms/RichContentSection/RichContentSection";
import {
	FAQSection,
	InlineCTA,
	SizeComparisonModule,
	RelatedContentSection,
	StorageNearYou,
	StorageHero,
	ContentSectionModule,
	StorageUnitSizeChart,
	RichContentSection,
	PspLinks
} from "components/organisms";
import ReviewCardList from "components/landing/ReviewCardList";

const ModuleMap = {
	"content-section": ContentSectionModule,
	"inline-cta": InlineCTA,
	"related-content": RelatedContentSection,
	"size-comparison": SizeComparisonModule,
	faq: FAQSection,
	"size-chart": StorageUnitSizeChart,
	"video-content": RichContentSection,
	"nearby-cities": StorageNearYou,
	"psp-links": PspLinks,
	reviews: ReviewCardList,
	"hero-section": StorageHero
};

function ModuleFactory({ type, props, children, handleSearch }) {
	const Component = ModuleMap[type];
	if (Component) {
		return (
			<Component
				{...props}
				handleSearch={handleSearch}
			>
				{children}
			</Component>
		);
	}
	return null;
}

ModuleFactory.propTypes = {
	type: PropTypes.string,
	props: PropTypes.object,
	children: PropTypes.node,
	handleSearch: PropTypes.func
};

ModuleFactory.defaultProps = {
	props: {},
	type: "PSP",
	children: null
};

export default ModuleFactory;
